import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useCopaySchedule from "./hooks/useCopaySchedule";

const CopaySchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
  setFalg,
  setScheduleDesc,
  onNavigate,
}) => {
  const copayScheduleData = useCopaySchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData,
    setFalg,
    setScheduleDesc,
    onNavigate
  );
  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={copayScheduleData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {copayScheduleData.screen_title} -{" "}
          <span className="heading-cod">{copayScheduleData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={copayScheduleData.formFields}
        dropdownValues={copayScheduleData.dropdownValues}
        paramsData={copayScheduleData.paramsData}
        updataParamData={copayScheduleData.updateParamData}
        disabledDropdown={copayScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={copayScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={copayScheduleData.selectMode}
        data={copayScheduleData.data}
        parmKey={copayScheduleData.parmKey}
        statusKey={copayScheduleData.statusKey}
        menuOptions={copayScheduleData.menuOptions}
        tableHeaders={copayScheduleData.columnDef}
        setRowData={copayScheduleData.setRowData}
        selectedPriceSchedules={copayScheduleData.selectedRows}
        setSelectedPriceSchedules={copayScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={copayScheduleData.first}
          rows={copayScheduleData.rows}
          totalRecords={copayScheduleData.totalRecords}
          currentPage={copayScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={copayScheduleData.onPageChange}
        />
      </div>
      {copayScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={copayScheduleData.isConfirmationModalOpen}
          onRequestClose={copayScheduleData.closeConfirmationModal}
          onBack={copayScheduleData.closeConfirmationModal}
          onSave={copayScheduleData.deleteCopaySchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={copayScheduleData.setSelectedOption}
        />
      )}
      {copayScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={copayScheduleData.isHideConfirmationModalOpen}
          onRequestClose={copayScheduleData.closeHideConfirmationModal}
          onBack={copayScheduleData.closeHideConfirmationModal}
          onSave={copayScheduleData.hideCopaySchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={copayScheduleData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default CopaySchedule;
